import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '../i18n';

const FLAG: Record<SupportedLanguage, string> = {
  ru: 'RU',
  en: 'EN',
  zh: 'ZH',
};

/**
 * Переключатель языка. На skeleton-этапе — простая группа кнопок.
 * В следующих PR можно перевести на dropdown с флагами.
 */
export function LanguageSwitcher(): JSX.Element {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language) as SupportedLanguage;

  return (
    <div
      className="inline-flex items-center gap-1 rounded-md border border-ntr-primary/20 bg-white p-1 shadow-sm"
      role="group"
      aria-label={t('language.label')}
    >
      {SUPPORTED_LANGUAGES.map((lng) => {
        const active = current === lng;
        return (
          <button
            key={lng}
            type="button"
            data-testid={`lang-${lng}`}
            aria-pressed={active}
            onClick={() => {
              void i18n.changeLanguage(lng);
            }}
            className={
              'rounded-sm px-2 py-1 text-xs font-semibold uppercase tracking-wide transition ' +
              (active
                ? 'bg-ntr-primary text-white'
                : 'text-ntr-text hover:bg-ntr-primary/10')
            }
          >
            {FLAG[lng]}
          </button>
        );
      })}
    </div>
  );
}
